import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase';
import { createUser, removeUser, updateUserEmail, updateUserPassword } from '../services/firebase/auth';
import { toast } from 'react-hot-toast';
import { getFirestore, collection, getDocs, doc, setDoc, deleteDoc, updateDoc, query, where } from 'firebase/firestore';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [db, setDb] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const register = async (email, password) => {
    try {
      const user = await createUser(email, password);
      toast.success('Kullanıcı başarıyla oluşturuldu');
      return user;
    } catch (error) {
      console.error('Error registering user:', error);
      toast.error('Kullanıcı oluşturulurken bir hata oluştu');
      throw error;
    }
  };

  const deleteAccount = async (userId) => {
    try {
      await removeUser(userId);
      toast.success('Hesap başarıyla silindi');
      return true;
    } catch (error) {
      console.error('Error deleting user:', error);
      toast.error('Hesap silinirken bir hata oluştu');
      throw error;
    }
  };

  const updateEmail = async (userId, newEmail) => {
    try {
      await updateUserEmail(userId, newEmail);
      toast.success('E-posta adresi başarıyla güncellendi');
      return true;
    } catch (error) {
      console.error('Error updating email:', error);
      toast.error('E-posta adresi güncellenirken bir hata oluştu');
      throw error;
    }
  };

  const updatePassword = async (userId, newPassword) => {
    try {
      await updateUserPassword(userId, newPassword);
      toast.success('Şifre başarıyla güncellendi');
      return true;
    } catch (error) {
      console.error('Error updating password:', error);
      toast.error('Şifre güncellenirken bir hata oluştu');
      throw error;
    }
  };

  const value = {
    user,
    loading,
    register,
    deleteAccount,
    updateEmail,
    updatePassword
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext; 